import * as React from "react";

const Account = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer10"
      fill="none"
      fillOpacity="1"
      stroke="#000"
      strokeDasharray="none"
      strokeDashoffset="3.477"
      strokeLinecap="round"
      strokeLinejoin="miter"
      strokeOpacity="1"
      strokeWidth="0.4"
    >
      <circle id="path41" cx="3.175" cy="1.85" r="1.247" opacity="1"></circle>
      <path
        id="path42"
        d="M1.915 3.297c-.458.315-.816.936-.952 1.465-.156.623.624 1.059 2.212 1.059m1.26-2.524c.458.315.816.936.952 1.466.156.622-.625 1.058-2.212 1.058"
        opacity="1"
      ></path>
    </g>
  </svg>
);

export default Account;
